<template>
<div>
    <show-goods-table :goods-list="goodsList"  :isForm="true"  :class="$style['promotion-form-table']" :firstColumnPrice="false">
        <template>
            <el-table-column label="商品规格">
                <template slot-scope="scope">
                    {{scope.row.specifications.name}}
                </template>
            </el-table-column>
            <el-table-column label="价格（元）">
                <template slot-scope="scope">
                    {{scope.row.final_price_no_sign}}
                </template>
            </el-table-column>
            <el-table-column label="优惠劵" min-width="350">
                <template slot-scope="scope">
                <el-button :disabled="isActive" type="primary" :class="isShowCouponList(scope.row)?$style['has-list-add-button']:''" plain @click="addCoupons(scope.row)">添加优惠劵</el-button>
                <template v-if="isShowCouponList(scope.row)" >
                <el-table :data="customerType==='shower'?scope.row.sharerCouponsBack:scope.row.buyerCouponsBack">
                    <el-table-column label="优惠劵名称">
                        <template slot-scope="scope_coupon">
                        {{scope_coupon.row.couponData&&scope_coupon.row.couponData.name}}
                        </template>
                    </el-table-column>
                    <el-table-column label="优惠劵内容">
                        <template slot-scope="scope_coupon">
                        <div>{{scope_coupon.row.discount}}</div>
                        <div>满{{scope_coupon.row.thresholdOfAmount}}元可使用</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="发放数量（张）">
                        <template  slot-scope="scope_coupon">
                            <wt-input :disabled="isActive" v-model="scope_coupon.row.couponAmount"></wt-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope_coupon">
                            <el-button :disabled="isActive" type="text" @click="deleteCoupons(scope.row,scope_coupon.row,scope.$index)">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                </template>
                </template>
            </el-table-column>
            <!-- <el-table-column label="优惠劵内容">

            </el-table-column>
            <el-table-column label="发放数量">

            </el-table-column> -->
        </template>
    </show-goods-table>
    <el-dialog :visible="is_dialog"  :title="dialog_title" @close="closeDialog">
         <coupon-list v-if="is_select_coupon" @selectCouponSubmit="selectCouponSubmit"  @close="closeDialog" :selected-coupon="coupon_list"></coupon-list>
    </el-dialog>
</div>
</template>
<script>
import showGoodsTable from '../show-goods-table'
import couponList from '../coupon-list'
export default {
  components: {
    showGoodsTable,
    couponList
  },
  props: {
    value: {
      type: Array,
      default: function () {
        return []
      }
    },
    customerType: {
      type: String,
      default: null
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    is_dialog: {
      get: function () {
        return this.is_select_coupon
      },
      set: function (val) {
        this.is_select_coupon = val
      }
    }
  },
  data () {
    return {
      itemId: null,
      is_select_coupon: false,
      dialog_title: '选择优惠劵',
      coupon_list: null,
      goodsId: null,
      goodsList: JSON.parse(JSON.stringify(this.value))
    }
  },
  watch: {
    customerType (val) {
      this.goodsList.forEach(item => {
        if (item.specifications.itemId === this.itemId) {
          if (val === 'buyer') {
            this.$set(item, 'buyerCouponsBack', this.coupon_list)
          } else if (val === 'shower') {
            this.$set(item, 'sharerCouponsBack', this.coupon_list)
          }
        }
      })
    },
    goodsList: {
      handler: function (val) {
        this.$emit('selelctGoods', val)
        // this.$emit('input', val)
      }
    },
    value: {
      handler: function (val) {
        this.$set(this, 'goodsList', val)
      },
      immediate: true
    }
  },
  methods: {
    deleteCoupons (goodsRow, row, index) {
      if (this.customerType === 'buyer') {
        goodsRow.buyerCouponsBack.splice(index, 1)
      } else if (this.customerType === 'shower') {
        goodsRow.sharerCouponsBack.splice(index, 1)
      }
    },

    // 是否显示优惠劵列表
    isShowCouponList (row) {
      return (this.customerType === 'buyer' && row.buyerCouponsBack && row.buyerCouponsBack.length > 0) ||
      (this.customerType === 'shower' && row.sharerCouponsBack && row.sharerCouponsBack.length > 0)
    },
    selectCouponSubmit (val) {
      this.is_select_coupon = false
      this.coupon_list = val
      this.goodsList.forEach(item => {
        if (item.goodsDTO && item.goodsDTO.goodsData && item.goodsDTO.goodsData.goodsId === this.goodsId && item.specifications.itemId === this.itemId) {
          if (this.customerType === 'buyer') {
            this.$set(item, 'buyerCouponsBack', val)
          } else if (this.customerType === 'shower') {
            this.$set(item, 'sharerCouponsBack', val)
          }
        }
      })
      this.$emit('selectCouponSubmit', this.goodsList)
    },
    closeDialog () {
      this.is_select_coupon = false
    },
    addCoupons (row) {
      this.itemId = row.specifications.itemId
      this.goodsId = row.goodsDTO && row.goodsDTO.goodsData && row.goodsDTO.goodsData.goodsId
      this.goodsList.forEach(item => {
        if (item.specifications.itemId === this.itemId && item.goodsDTO && item.goodsDTO.goodsData && item.goodsDTO.goodsData.goodsId === this.goodsId) {
          if (this.customerType === 'buyer') {
            if (item.buyerCouponsBack) {
              this.coupon_list = item.buyerCouponsBack
            } else {
              this.coupon_list = null
            }
          } else if (this.customerType === 'shower') {
          }
        }
      })
      this.is_select_coupon = true
    }
  },
  created () {
    console.log('goodsList', this.value)
  }
}
</script>
<style module lang="less">
.promotion-form-table{
margin-top: 20px;
padding:0;
background:#fff
}
.has-list-add-button{
    margin-bottom: 10px;
}
</style>
